import React, {useState} from "react";
import {Navigate, useLocation, useNavigate} from "react-router-dom";
import {
    Alert,
    Button,
    Card,
    CardBody,
    CardTitle,
    Col,
    Container,
    Form,
    FormGroup,
    Input,
    Label,
    Row,
    Spinner,
} from "reactstrap";
import {useAuth} from "./AuthProvider";
import IconLabel from "../shared/components/IconLabel";
import {LoginIcon} from "../shared/components/icons";

const errorMessage = (error) => {
    const status = error.response?.status;
    if (status === 401 || status === 400) {
        return "Usuário ou senha inválidos.";
    }
    if (!error.response) {
        return "Não foi possível conectar ao servidor. Tente novamente.";
    }
    return "Algo deu errado. Tente novamente.";
};

const Login = () => {
    const {isAuthenticated, login} = useAuth();
    const navigate = useNavigate();
    const location = useLocation();
    const from = location.state?.from?.pathname || "/";

    const [username, setUsername] = useState("");
    const [password, setPassword] = useState("");
    const [error, setError] = useState(null);
    const [submitting, setSubmitting] = useState(false);

    if (isAuthenticated) {
        return <Navigate to={from} replace />;
    }

    const handleSubmit = async (event) => {
        event.preventDefault();
        setError(null);
        setSubmitting(true);
        try {
            await login(username, password);
            navigate(from, {replace: true});
        } catch (err) {
            setError(errorMessage(err));
            setPassword("");
            setSubmitting(false);
        }
    };

    return (
        <Container className="mt-5">
            <Row className="justify-content-center">
                <Col md="6" lg="4">
                    <Card>
                        <CardBody>
                            <CardTitle tag="h4" className="mb-4">
                                Entrar
                            </CardTitle>
                            {error && <Alert color="danger">{error}</Alert>}
                            <Form onSubmit={handleSubmit}>
                                <FormGroup>
                                    <Label for="username">Usuário</Label>
                                    <Input
                                        id="username"
                                        name="username"
                                        autoComplete="username"
                                        autoFocus
                                        required
                                        value={username}
                                        onChange={(e) => setUsername(e.target.value)}
                                    />
                                </FormGroup>
                                <FormGroup>
                                    <Label for="password">Senha</Label>
                                    <Input
                                        id="password"
                                        name="password"
                                        type="password"
                                        autoComplete="current-password"
                                        required
                                        value={password}
                                        onChange={(e) => setPassword(e.target.value)}
                                    />
                                </FormGroup>
                                <Button
                                    color="primary"
                                    type="submit"
                                    block
                                    disabled={submitting || !username || !password}
                                >
                                    {submitting ? (
                                        <Spinner size="sm" />
                                    ) : (
                                        <IconLabel icon={<LoginIcon />}>Entrar</IconLabel>
                                    )}
                                </Button>
                            </Form>
                        </CardBody>
                    </Card>
                </Col>
            </Row>
        </Container>
    );
};

export default Login;
